import React from "react";

const TONES={
  neutral:{background:"var(--surface-inset)",color:"var(--fg-2)"},
  brand:{background:"var(--surface-brand-soft)",color:"var(--fg-brand)"},
  accent:{background:"var(--surface-accent-soft)",color:"var(--cyan-700)"},
  success:{background:"var(--surface-success)",color:"var(--text-success)"},
  warning:{background:"var(--surface-warning)",color:"var(--text-warning)"},
  danger:{background:"var(--surface-danger)",color:"var(--text-danger)"},
  info:{background:"var(--surface-info)",color:"var(--text-info)"},
  ink:{background:"var(--teal-900)",color:"var(--fg-invert)"}
};

export function Badge({tone="neutral",dot=false,children,style,...rest}){
  return (
    <span style={{display:"inline-flex",alignItems:"center",gap:"6px",height:"22px",padding:"0 8px",
      borderRadius:"var(--radius-1)",fontFamily:"var(--font-display)",fontSize:"var(--text-3xs)",
      fontWeight:"var(--weight-semibold)",letterSpacing:"var(--tracking-label)",textTransform:"uppercase",whiteSpace:"nowrap",
      ...TONES[tone],...style}} {...rest}>
      {dot&&<span style={{width:5,height:5,borderRadius:"50%",background:"currentColor"}}/>}
      {children}
    </span>
  );
}
